module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2IRZj"))).then(() => parcelRequire('d0iPb'));